export default __webpack_public_path__ + "static/media/brand-hero-border-bottom.9cf0038d.svg";